import { Box, Card, CardContent, Typography } from "@mui/material";
import { CHART_COLORS, chartSx } from "../../../../components/charts/chartTheme";

import { BarChart } from "@mui/x-charts/BarChart";
import { SubjectGrade } from "../types";
import { PlaceholderBadge } from "./PlaceholderBadge";
import { EmptyState } from "./EmptyState";
import { cardTitleSx, dashboardCardSx } from "../responsiveText";

type SubjectGradesCardProps = {
  data: SubjectGrade[];
  classAverage: number | null;
};

export const SubjectGradesCard = ({ data, classAverage }: SubjectGradesCardProps) => {
  const sorted = [...data].sort((a, b) => b.score - a.score);

  return (
    <Card elevation={0} sx={dashboardCardSx}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="subtitle1" fontWeight={600} sx={cardTitleSx}>
              Subject Performance
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {classAverage != null ? `Term 1 · Class average ${classAverage}%` : "Term 1"}
            </Typography>
          </Box>
          <PlaceholderBadge />
        </Box>

        {data.length === 0 ? (
          <EmptyState message="No grades published yet" height={240} />
        ) : (
          <Box sx={{ mt: 1 }}>
            <BarChart
              xAxis={[{ scaleType: "band", data: sorted.map((s) => s.shortLabel), disableTicks: true, categoryGapRatio: 0.45 }]}
              yAxis={[{ min: 0, max: 100, width: 40, disableLine: true, disableTicks: true, valueFormatter: (v: number) => `${v}%` }]}
              series={[
                {
                  data: sorted.map((s) => s.score),
                  label: "Score",
                  color: CHART_COLORS.series1,
                },
              ]}
              height={240}
              borderRadius={6}
              hideLegend
              grid={{ horizontal: true }}
              sx={chartSx}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
